import _ from 'lodash';
import {
  FETCH_PROPERTYUNITS,
  PUSH_PROPERTYUNITS,
  REMOVE_PROPERTYUNITS,
  UPDATE_PROPERTYUNITS,
  UPDATE_MODE,
  UPDATE_ACTIVE_ID } from '../actions/actions-propertyunits';

const INITIAL_STATE = {
  propertyunits: [],
  mode: 'index',
  activeId: '',
  activePropertyunits:{}
}


export default function(state = INITIAL_STATE, action){
  switch(action.type){
    case FETCH_PROPERTYUNITS:
      return {
        ...state,
        propertyunits:action.payload,
      }
    case PUSH_PROPERTYUNITS:
      return {
        ...state,
        propertyunits:[action.payload, ...state.propertyunits],
      }
    case REMOVE_PROPERTYUNITS:
      return {
        ...state,
        propertyunits : [...state.propertyunits.filter( (item) => item._id !== action.payload._id)]
      }
    case UPDATE_PROPERTYUNITS:
      let index =  _.findIndex(state.propertyunits, { '_id': action.payload._id })
      state.propertyunits.splice(index, 1, action.payload)
      return {
        ...state,
        propertyunits : state.propertyunits
      }
    case UPDATE_MODE:
      return {
        ...state,
        mode : action.payload,
        activeId:''
      }
    case UPDATE_ACTIVE_ID:
      return {
        ...state,
        mode : action.mode,
        activeId:action.id,
        activePropertyunits: _.pick(_.find(state.propertyunits, { '_id': action.id }), ['propertyId','block', 'floor','unitNo','street','size','extraSize','referenceId', '_id','owner'])
      }
    default:
      return state

  }
}
